<div class="container-fluid">
    <!--Barra de progreso-->
    <div class="progress-cajas mt-3" [ngStyle]="{'background-color': color2 }">
        <div class="progress2-cajas" [ngStyle]="{'width': progress + '%', 'background-color': color1  }"></div>
        <div> 
            <div *ngIf="progress >= 25" class="position-absolute text-white ms-4 fw-bold d-flex align-items-center">
                <mat-icon>trending_up</mat-icon>
                <label class="ms-2">L{{linea}} - {{cajas_encintadas}}</label>
            </div>
            <div class="circle-label position-absolute text-center fw-bold"
                [ngStyle]="{ left: progress + '%', transform: 'translateX(-50%)', color: color1 }">
                <label>{{ progress }}%</label>
            </div>
            <div *ngIf="progress < 25" class="position-absolute text-white fw-bold d-flex align-items-center" style="right: 40px;">
                <mat-icon>trending_up</mat-icon>
                <label class="ms-2">L{{linea}} - {{cajas_encintadas}}</label>
            </div>
        </div> 
    </div>
    <!--Objetivo y tiempo-->
    <div class="row text-start mt-4">
      <div class="row">
        <div class="col-md-3 col-sm-6 col-xs-6 d-flex align-items-center">
            <mat-icon class="icono-amarillo2 icon-sm">workspace_premium</mat-icon>
            <label class="fw-bold ms-2">Objetivo</label>
        </div>
        <div class="col-md-9 col-sm-6 col-xs-6 d-flex align-items-center">
            <mat-icon class="icono-azul icon-sm">timer</mat-icon>
            <label class="fw-bold ms-2">Tiempo aproximado de empaque</label>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-md-3 col-sm-6 col-xs-6">
            <label style="margin-left: 2.2rem">{{cajas_x_linea}}</label>
        </div>
        <div class="col-md-9 col-sm-6 col-xs-6">
            <label style="margin-left: 2.2rem">{{promedio}} min</label>
        </div>
      </div>
    </div>
</div>

